/**
 * users.js
 * Path: frontend/src/api/users.js
 * Description: Wywołania API listy aktywnych użytkowników.
 * Related: pages/CalendarPage.jsx, components/JobFormModal.jsx
 */

import { api, authHeaders } from "./apiBase";

export async function listActiveUsers(token) {
  const response = await api.get("/users", { headers: authHeaders(token) });
  return Array.isArray(response.data) ? response.data : [];
}

